import { Link, Stack } from "expo-router";
import { StyleSheet, Text, View } from "react-native";

// TODO: replace boilerplate with own implementation
export default function NotFoundScreen() {
  return (
    <>
      <Stack.Screen options={{ title: "Oops!" }} />
      <View style={styles.container}>
        <Text style={styles.title}>{"This screen doesn't exist."}</Text>

        <Link
          href={{ pathname: "/[uuid]/", params: { uuid: "123" } }}
          style={styles.link}
        >
          <Text style={styles.linkText}>/123</Text>
        </Link>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: "#2e78b7",
  },
});
